var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hub-spot-contact-form-container"},[(_vm.loading)?_c('div',{staticClass:"loading-ellipsis",attrs:{"role":"alert","aria-live":"polite","aria-label":"Loading contact form"}}):_c('div',{staticClass:"hub-spot-contact-form",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }